module.exports = __webpack_public_path__ + "img/rotterdam4.c8f86b67.jpg";